import { ERROR, LOADING, READY, useVisualState } from '../../../hooks/useVisualState'
import React, { useEffect, useRef, useState } from 'react'

import NewCompetitionStepFive from './modules/NewCompetitionStepFive'
import NewCompetitionStepFour from './modules/NewCompetitionStepFour'
import NewCompetitionStepOne from './modules/NewCompetitionStepOne'
import NewCompetitionStepSeven from './modules/NewCompetitionStepSeven'
import NewCompetitionStepSix from './modules/NewCompetitionStepSix'
import NewCompetitionStepThree from './modules/NewCompetitionStepThree'
import NewCompetitionStepTwo from './modules/NewCompetitionStepTwo'
import { get } from '../../../helpers/request'
import t from '../../../helpers/i18n'
import { withRouter } from 'react-router-dom'

const TOTAL_STEPS = 7

const NewCompetitionView = ({ history, match }) => {
  const [step, setStep] = useState(0)
  //const [competitionId, setCompetitionId] = useState(match.params.competitionId)
  const [[, divisions], setDivisions] = useVisualState()
  const [[, events], setEvents] = useVisualState()
  const [, setStepOneValid] = useState(false)
  const [, setStepTwoValid] = useState(false)
  const [, setStepThreeValid] = useState(false)
  const [, setStepFourValid] = useState(false)
  const [, setStepFiveValid] = useState(false)
  const [, setStepSixValid] = useState(false)
  const [, setStepSevenValid] = useState(false)
  const stepOneData = useRef({})
  const stepTwoData = useRef({})
  const stepThreeData = useRef({})
  const stepFourData = useRef({})
  const stepFiveData = useRef({})
  const stepSixData = useRef({})
  const stepSevenData = useRef({})

  const handleNextStep = async () => {
    // TODO: hack
    return setStep(step + 1)
    /*
    try {
      if (step === 0 && stepOneValid) {
        const result = await post('/soccer/competitions' + (competitionId ? '/' + competitionId : ''), stepOneData.current)
        setCompetitionId(result.competition_id)
        setStep(step + 1)
      }
    } catch (error) {
      // TODO: show an error message?
    }
    */
  }

  useEffect(() => {
    setDivisions(LOADING)
    get('/soccer/competitions/divisions')
      .then((response) => {
        setDivisions(READY, response)
      })
      .catch((error) => {
        setDivisions(ERROR, error)
      })
  }, [setDivisions])

  useEffect(() => {
    setEvents(LOADING)
    get('/soccer/competitions/events')
      .then((response) => {
        setEvents(READY, response)
      })
      .catch((error) => {
        setEvents(ERROR, error)
      })
  }, [setEvents])

  return (
    <div>
      {step === 0 && (
        <NewCompetitionStepOne
          data={stepOneData}
          setFormValid={setStepOneValid}
          divisions={divisions}
          events={events}
        />
      )}
      {step === 1 && (
        <NewCompetitionStepTwo
          data={stepTwoData}
          setFormValid={setStepTwoValid}
          divisions={stepOneData.current.divisions}
        />
      )}
      {step === 2 && (
        <NewCompetitionStepThree
          data={stepThreeData}
          setFormValid={setStepThreeValid}
        />
      )}
      {step === 3 && (
        <NewCompetitionStepFour
          data={stepFourData}
          setFormValid={setStepFourValid}
        />
      )}
      {step === 4 && (
        <NewCompetitionStepFive
          data={stepFiveData}
          setFormValid={setStepFiveValid}
        />
      )}
      {step === 5 && (
        <NewCompetitionStepSix
          data={stepSixData}
          setFormValid={setStepSixValid}
        />
      )}
      {step === 6 && (
        <NewCompetitionStepSeven
          data={stepSevenData}
          setFormValid={setStepSevenValid}
        />
      )}
      <div>
        {step > 0 && (
          <button onClick={() => setStep(step - 1)}>{t('buttons.Previous')}</button>
        )}
        {step < TOTAL_STEPS - 1 && (
          <button onClick={() => handleNextStep()}>{t('buttons.Next')}</button>
        )}
      </div>
    </div>
  )
}

export default withRouter(NewCompetitionView)
